import React from "react";
import "./DeleteConfirmModal.css";
interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  productName: string;
}

const DeleteConfirmModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  productName,
}) => {
  if (!isOpen) return null;

  return (
    <div className="delete-modal__overlay">
      <div className="delete-modal__box">
        <h3>Delete Confirmation</h3>
        <p>
          Are you sure you want to delete <strong>{productName}</strong>?
        </p>
        <div className="delete-modal__actions">
          <button className="btn cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="btn delete" onClick={onConfirm}>
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
